import { AES } from 'crypto-ts';
import * as CryptoTS from 'crypto-ts';
import { environment } from "src/environments/environment.dev";

export default class AESEncryptDecryptService {
  secretKey = environment.cryptoKey;
  constructor() {}

  encrypt(value: string): string {
    return AES.encrypt(value, this.secretKey).toString();
  }

  decrypt(textToDecrypt: string) {
    let bytes = AES.decrypt(textToDecrypt, this.secretKey);
    return bytes.toString(CryptoTS.enc.Utf8);
  }
}
